export default __webpack_public_path__ + "static/media/footer-top.df4b04c3.svg";